<template>
  <svg viewBox="0 0 2610 1722" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M641 1220v188l-92-83v-79c-179-78-317-233-372-423L20 709V582l133 96c0-12-1-24-1-36 0-5 0-11 1-16L0 517V319l230 165c-14 50-21 103-21 158 0 274 182 505 432 578zm282 14v226l-112 100-112-100v-226c36 6 74 10 112 10s75-4 112-10zm469-750l230-165v198l-153 109v52l133-96v127l-158 114c-54 190-192 345-371 423v79l-93 83v-188c250-73 433-304 433-578 0-55-7-108-21-158zM680 131L811 0l131 131-131 131zm347 30L811 377 595 161c15-7 31-13 47-19l169 169 168-169c16 6 32 12 48 19z" />
  </svg>
</template>
